module.exports = __webpack_public_path__ + "school/img/xueke3ji.ede44401.jpg";